export enum OPERATING_SYSTEM {
  WEB = 'Web',
  MAC = 'MacOS',
  WIN = 'Windows',
  ANDROID = 'Android',
  IOS = 'iOS'
}

export enum DaysOfWeek {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN'
}

export enum CalendarTypes {
  GOOGLE = 'google',
  YAHOO = 'yahoo',
  MICROSOFT_CALENDAR = 'microsoft_calendar',
  OUTLOOK = 'outlook',
  ICS = 'ics'
}

export enum CalendarTypeLabels {
  GOOGLE = 'Google',
  YAHOO = 'Yahoo',
  MICROSOFT_CALENDAR = 'Microsoft Calendar',
  OUTLOOK = 'Outlook',
  ICS = 'ICS File'
}

export enum AppDownloadButtonLabels {
  MAC = 'Mac',
  IOS = 'iOS',
  GOOGLE_PLAY = 'Google Play',
  WINDOWS = 'Windows'
}
export enum CalendarStatus {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  RECONNECT = 'reconnect'
}
